module.exports = __webpack_public_path__ + "static/media/cft_logo.3737f148.jpg";